/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import PropTypes            from 'prop-types';
import { Navigation }       from '../../../containers/Navigation';
import { NavigationLink }   from '../../../containers/NavigationLink';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const NavigationList = ({ items }) => (
    <Navigation>
        {items.map(item => <li key={item.id}><NavigationLink {...item}>{item.text}</NavigationLink></li>)}
    </Navigation>
);

NavigationList.propTypes = {
    items: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/molecules/NavigationList/index.js